import invariant from 'invariant';

export default function assertIncluded<T extends ReadonlyArray<unknown>>(
  value: unknown,
  array: T
): asserts value is T[number] {
  invariant(array.includes(value), `${value} is not in ${array}`);
}
